import { DateTime } from "luxon";

const complex = (pickup, row) => {
  if (row.fulfillment.type === "pickup") {
    const date = DateTime.fromISO(row.fulfillment.pickup.date).toLocaleString(
      DateTime.DATE_SHORT
    );
    const start = DateTime.fromISO(
      row.fulfillment.pickup.time.start
    ).toLocaleString(DateTime.TIME_SIMPLE);

    const end = DateTime.fromISO(
      row.fulfillment.pickup.time.end
    ).toLocaleString(DateTime.TIME_SIMPLE);
    return `<div>Pickup</div>
    <small class="d-block text-light font-weight-light">${date}</small>
    <small class="d-block text-light font-weight-light">${start}-${end}</small>`;
  } else {
    const date = DateTime.fromISO(row.pickup).toLocaleString(
      DateTime.DATE_SHORT
    );
    const time = DateTime.fromISO(row.pickup).toLocaleString(
      DateTime.TIME_SIMPLE
    );

    return `<div>Pickup</div>
    <small class="d-block text-light font-weight-light">${date}</small>
    <small class="d-block text-light font-weight-light">${time}</small>`;
  }
};

export default {
  complex
};
